import { h } from 'preact';

import { Trans } from '@lingui/macro';

export const ChangeNodeMenu = () => (
	<a href={'#/changenode'}><Trans>Visit a neighboring node</Trans></a>
);
